import { render, staticRenderFns } from "./BannerPhone.vue?vue&type=template&id=1635d9c6"
import script from "./BannerPhone.vue?vue&type=script&lang=js"
export * from "./BannerPhone.vue?vue&type=script&lang=js"
import style0 from "./BannerPhone.vue?vue&type=style&index=0&id=1635d9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports